module.exports = __webpack_public_path__ + "img/personel-flat-card-5.png";